export default class GenCli {
    constructor(resource) {
        this._resource = resource('avisos_supo');
    }

    get(filtro) {
        return this._resource
            .get({filtro: filtro})
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    sendEmail(filtro, id) {
        return this._resource
            .get({filtro: filtro, id: id})
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    save(rdata) {
        return this._resource
            .save({}, rdata)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    delete(rid) {
        return this._resource
            .delete({rid:rid})
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }
}